module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic16.bdd9423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic16.png
// module id = 567
// module chunks = 1